export enum ECurrency {
  USD = 'USD',
  EUR = 'EUR',
}

export enum ECurrencyValue {
  USD = 'usd',
  EUR = 'eur',
}
